export const sizePerPageList = [
	{ text: '20', value: 20 },
	{ text: '50', value: 50 },
	{ text: '100', value: 100 },
]
